export default __webpack_public_path__ + "static/ambient-ai-eb896aa29c24f1ec637b26ce6e74cc6629efb25d4b0d921d665c48333fee0e84.png";